<template>
    <div class="home overflow-x-hidden">
        <header class="h-screen w-screen">
            <div class="h-screen w-screen header-wrapper flex">
                <a href="tel:337-509-0162">
                    <button 
                        class="bg-dark-navy-850 shadow-md rounded-br-xl h-auto fixed flex py-4 px-4 z-50 text-green-500">
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            class="h-8 w-8" 
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                        </svg>
                    </button>
                </a>
                <div class="my-auto mx-auto text-white">
                    <p class="text-center uppercase text-2xl font-semibold">Discover Your</p>
                    <h1 class="text-7xl xl:text-9xl font-bold pt-4">Authentic Self</h1>
                    <p class="text-center uppercase text-2xl font-medium relative top-3">Through Therapy</p>
                   
                    <div class="mt-12 text-center">
                        <CTA 
                            phone="337-509-0162"
                            formattedPhone="(337) 509-0162"
                            :otherTherapist="otherTherapist"/>
                        <!-- <button
                            @click="popupCalendar"
                            class="bg-green-400 text-black font-bold uppercase shadow-md rounded-md py-2 px-2 md:py-4 md:px-4 3xl:text-lg hover:shadow-lg focus:outline-none"
                            type="button">
                            FREE 30-Min Consultation 
                        </button> -->
                    </div>
                </div>
            </div>
        </header>
        <!-- Questions -->
        <!-- <section class="bg-pale-green-2 px-4 flex border-t-4 border-green-300">
            <div class="bg-white xl:w-screen-60 relative bottom-0 mt-4 sm:bottom-40 3xl:bottom-48 mx-auto shadow-xl rounded-lg py-6">
                <div class="md:grid md:grid-cols-8 md:gap-10 px-6 py-4">
                    <div class="col-span-8 text-center pb-6">
                        <p class="font-bold xl:text-2xl">
                            Do any of these statements sound familiar?
                        </p>
                    </div>
                   
                    <div 
                        class="col-span-4" 
                        v-for="(question, i) in questions"
                        :key="`question-${i}`">
                        <article class="flex justify-start py-4">
                            <span class="my-auto pr-4 text-green-400">
                                <svg 
                                    xmlns="http://www.w3.org/2000/svg" 
                                    class="h-10 w-10 text-yellow-300" 
                                    fill="none" 
                                    viewBox="0 0 24 24" 
                                    stroke="currentColor">
                                    <path 
                                        stroke-linecap="round" 
                                        stroke-linejoin="round" 
                                        stroke-width="2" 
                                        d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                    />
                                </svg>
                            </span>
                            <p class="text-gray-600 xl:text-xl">
                                {{question}}
                            </p>
                        </article>
                    </div>
                </div>
                <div class="flex justify-center pt-10 px-4">
                    <CTA
                        class="" 
                        phone="561-601-6345"
                        formattedPhone="(561) 601-6345"
                        :otherTherapist="otherTherapist"
                    />
                </div>
            </div>
        </section> -->
        <!-- who this is for -->
        <section class="bg-pale-green-2 min-h-screen flex">
            <div class="xl:w-screen-60 mx-auto relative pt-10">
                <h2 class="text-center text-4xl xl:text-7xl font-semibold">
                    Who This is For
                </h2>
                <div class="py-10">
                    <div class="flex px-4">
                        <div class="py-4">
                            <div class="md:px-10">
                                <article class="flex py-2" v-for="statement in whoItsFor" :key="statement">
                                    <span class="my-auto text-green-400 rounded-full bg-white py-2 px-2 shadow-md">
                                        <svg 
                                            xmlns="http://www.w3.org/2000/svg" 
                                            fill="none" 
                                            viewBox="0 0 24 24" 
                                            stroke="currentColor"
                                            class="h-10 w-10">
                                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
                                        </svg>
                                    </span>
                                    <p class="text-gray-600 xl:text-xl pl-4 my-auto">
                                        {{ statement }}
                                    </p>
                                </article>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Who Am I -->
        <section class="bg-white min-h-screen/2 py-2 flex px-4" >
            <div class="relative bottom-16 2xs:bottom-18 xl:bottom-60 xl:w-screen-60 mx-auto bg-white shadow-xl py-6 rounded-lg" id="ronda">
                <div class="">
                    <h2 class="text-center text-4xl xl:text-7xl font-semibold">
                        Who Am I?
                    </h2>
                </div>
                <div class="px-4 py-8 md:py-8">
                    <div class="pb-6">
                        <img 
                            src="https://thrive-unburdened.s3.amazonaws.com/TU/renee-2.jpg"
                            alt="Staff Member" 
                            class="mx-auto border-4 border-green-400 object-cover rounded-full h-64 w-64 xl:w-80 xl:h-80">
                    </div>
                    <div class="md:flex md:justify-between py-4">
                        <div class="py-4 md:px-10">
                            <article class="py-2 text-gray-600 text-base md:text-lg xl:text-xl">
                                <p>
                                   Hello, I’m Renee Leftwich-Render, and I am deeply passionate about guiding
individuals and couples on their journey towards self-discovery and emotional
well-being.
                                </p>
                                <p>
                                   As a dedicated mental health therapist, I specialize in helping clients navigate life’s
challenges to unearth their true, authentic selves. In my practice, I provide
compassionate counseling to individuals grappling with a range of issues,
including depression, anxiety, self-esteem struggles, body image concerns, post-
traumatic stress, grief, women’s issues, and the complexities of multicultural
identity.
                                </p>
                                 
                            </article>
                        
                            <article class="py-2 text-gray-600 text-base md:text-lg xl:text-xl">
                              <p>
                               Life has a way of throwing us unexpected curveballs, doesn’t it? It’s during those
times of upheaval that feelings of loneliness and uncertainty can creep in. Drawing
from my own experiences as a military spouse and having grown up as a military
brat myself, I intimately understand the unique trials and tribulations faced by
military families. Moreover, I empathize deeply with the challenges of navigating
grief, managing anxiety, and confronting those unexpected twists and turns that life
presents. Whether you&#39;re contending with frequent relocations, the stress of
deployment, or the complexities of reintegration, I offer a safe space for you to
explore your emotions and navigate the unique transitions and challenges of your
life.
                              </p>
                              <br>
                              <p>
                            If you’re feeling adrift in the tumult of life’s challenges, I’m here to extend a
lifeline of support.
                              </p>
                              <br>
                              <p>
                            In our sessions together, I prioritize collaboration and tailoring my approach to
meet your specific needs, desires, and goals. I draw from a diverse range of
therapeutic modalities, including cognitive behavioral therapy, choice therapy,
person-centered therapy, and somatic therapy. By adapting my interventions to
align with your individual journey, I strive to create a supportive environment
where healing and growth can flourish.
                              </p>
                              <br>
                              
                              <p>
                               If you’re ready to take the first step towards positive change, I invite you to reach
out for a complimentary 15-minute online consultation.
                              </p>
                              <p>
                                Together, we can embark on a journey towards greater self-awareness, resilience,
and authentic living.
                              </p>

                            </article>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="min-h-screen/2 last-cta">
            <div class="flex min-h-screen/2 last-cta-wrapper">
                <div class="mx-auto my-auto text-center">
                    <h2 class="font-bold text-4xl xl:text-7xl text-white py-6">Ready to Thrive?</h2>
                    <div class="flex justify-center py-4 px-4 pb-10">
                        <CTA
                            class="text-white" 
                            phone="337-509-0162"
                            formattedPhone="(337) 509-0162"
                            :otherTherapist="otherTherapist"
                        />
                        <!-- <button
                            @click="popupCalendar"
                            class="bg-green-400 text-black font-bold uppercase shadow-md rounded-md py-2 px-2 md:py-4 md:px-4 3xl:text-lg hover:shadow-lg focus:outline-none"
                            type="button">
                            FREE 30-Min Consultation
                        </button> -->
                    </div>
                </div>
            </div>
        </section>
        <footer class="bg-white border-t-2 border-green-400 py-8 px-4">
            <div class="pb-4">
                <a href="https://thriveunburdened.com/" target="_blank">
                    <img src="@/assets/thrive-logo-green-2.png" alt="Thrive Unburdened" class="mx-auto w-32">
                </a>
                <PsychologyToday />
            </div>
            <div class="text-center text-sm mx:text-base">
                Copyright &copy; 2020 - {{year}}  Thrive Unburdened, Inc <br> Renée Leftwich-Render, MA, PLPC<br>
                <p class="pt-2 text-xs">Developed by 
                    <a href="https://github.com/freinet12" target="_blank" class="font-medium text-gray-700 hover:underline">Freinet Brutus</a>
                </p>
            </div>
        </footer>
    </div>
</template>

<script>
    import TuModal from '@/components/TuModal'
    import cryptoRandomString from 'crypto-random-string'
    import PsychologyToday from '@/components/psychologyToday'
    import CTA from '@/components/CallToAction'
    export default {
        name: "Home",
        components: {
            TuModal,
            PsychologyToday,
            CTA
        },

        computed: {
            modalId(){
                return cryptoRandomString({length: 10, type: 'base64'})
            },
            apptScheduled(){
                return eval(this.$route.query['cal-appt-sched']) || false
            }
        },

        watch: {
            apptScheduled(){
                this.handleApptScheduled()
            }
        },

        mounted(){
            this.handleApptScheduled()
        },

        data() {
            return {
                showModal: false,
                date: new Date("December 1, 2020 14:00:00"),
                year: '',

                

                whoItsFor: [
                    `Are you yearning for a different way to navigate life’s twists and turns?`,
                    `Do you long to cultivate healthier emotional coping mechanisms and find peace in the aftermath of trauma?`,
                    `Are you tired of wearing a mask and pretending everything is okay?`,
                    `Perhaps you’re seeking to improve communication, deepen understanding, and foster fair conflict resolution in your relationships.`,
                    `Whatever your aspirations may be, I am here to walk alongside you on your path to personal growth and fulfillment.`,
                    `Want to improve communication, understanding, and fighting fair in a relationship?`
                ],
            }
        },

        created() {
            this.setYear();
        },

        methods: {
            setYear() {
                let date = new Date();
                this.year = date.getFullYear();
            },

            popupCalendar(){
                Calendly.initPopupWidget({url: 'https://calendly.com/thriveunburdened/30-min-discovery-call'})
                return false
            },
            handleApptScheduled(){
                if (this.apptScheduled){
                    window.fbq.push('track', 'Lead')
                }
            }
        }

    };
</script>

<style scoped>
    @import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Playfair+Display:wght@400;700&display=swap');

    header{
        background: url('../assets/images/zen-stones.jpg');
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
        background-attachment: fixed;
    }

    .label{
        font-family: 'Dancing Script', cursive;
    }

    h1,h2,h3,h4{
        font-family: 'Playfair Display', Helvetica, sans-serif;
    }

    @media screen and (max-width: 450px) {
        .header-wrapper{
            background: rgb(0, 0, 0, 0.5)
        } 
        .last-cta{
            background: url('../assets/images/1.jpeg');
            background-size: 'contain';
            background-position: bottom;
        }
    }

    @media screen and (min-width: 451px) {
        .header-wrapper{
            background: rgb(0, 0, 0, 0.5)
        }
        .last-cta{
            background: url('../assets/images/1.jpeg');
            background-size: 'cover';
            background-position: left;
        }
    }
   

   

    .last-cta-wrapper{
        background: rgb(0, 0, 0, 0.5)
    }
</style>